export default "__VITE_ASSET__CrjHfPbo__"